import { Box } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade03,
  orangeBgColor,
} from "../../../configs/styles/muiThemes";
import PickAddressFromMap from "../../../components/AddressSelection/PickAddressFromMap";

const PickAddress = ({
  onConfirm,
  userLat,
  userLong,
  hideBackBtn,
  onBackClick,
}) => {
  return (
    <Box sx={styles.card}>
      <PickAddressFromMap
        isOpen={true}
        onConfirm={onConfirm}
        userLat={userLat}
        userLong={userLong}
        hideBackBtn={hideBackBtn}
        onBackClick={onBackClick}
      />
    </Box>
  );
};

export default PickAddress;

const styles = {
  card: {
    // width: { xs: "100%", md: "100%" },
    // mt: { md: "35px", xs: 1.5 },
  },

  headingText: {
    fontSize: { xs: 17, md: 18 },
    color: blackColor,
    fontWeight: 500,
    lineHeight: "30px",
    mb: "10px !important",
  },

  subText: {
    fontSize: { xs: 12, md: 12 },
    color: blackShade03,
    fontWeight: 400,
    lineHeight: { xs: "17px", md: "20px" },
    mb: "15px !important",
  },

  infoBox: {
    px: 3,
    py: 1,
    borderRadius: "7px",
    backgroundColor: orangeBgColor,
    mb: 2,
  },
};
